import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Skeleton } from '@chakra-ui/react';
import { Button } from '../../Button';
import { useCalendar } from './CalendarContext';
import { useCalendarStyles } from './CalendarStyleProvider';
export const CalendarTodayButton = () => {
    const styles = useCalendarStyles();
    const { handleTodayClick, colorScheme, isLoading } = useCalendar();
    return (_jsx(Box, { sx: styles.todayLinkContainer, children: _jsx(Skeleton, { isLoaded: !isLoading, children: _jsx(Button, { "aria-label": "Focus on today's date", colorScheme: colorScheme, variant: "link", type: "button", sx: styles.todayLink, onClick: handleTodayClick, children: "Today" }) }) }));
};
